$('.menu svg').click(function(){
    $('.navi').toggleClass('active');
});
$('main').click(function(event){
    $('.navi').removeClass('active');
});